import {useEffect, useState} from "react";
import Body from "../components/routing";
import LoadingPage from "../components/general/LoadingPage";
import {useSessionStore} from "../services/storage/SessionStorage";
import {ID_TOKEN} from "../conf";
import RoutingAuth from "./RoutingAuth";
import {clearCookiesAndCache, getSessionByCookie} from "../utils/decode/getSessionByCookie";

export default function Auth () {
    const [loading, setLoading] = useState(true);
    const [session, setSession]  = useState<string | null>();
    const data = useSessionStore(state => state.data)

    useEffect(() => {
        const tokenFromCookie = getSessionByCookie(ID_TOKEN);

        if (tokenFromCookie?.access_token) {
            setSession(tokenFromCookie?.access_token)
        } else {
            setSession(null)
            clearCookiesAndCache();
        }
        setLoading(false)
    }, [data]);

    if (loading) {
        return <LoadingPage />;
    }

    if (session) {
        return <Body />;
    }

    return <RoutingAuth />;
}
